/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import moment from 'moment';

export enum TSEigenleistungArt {
    HANDARBEIT = <any>'HANDARBEIT',
    HANDARBEIT_PAUSCHAL = <any>'HANDARBEIT_PAUSCHAL',
    TRAKTOR_SUB44KW = <any>'TRAKTOR_SUB44KW',
    TRAKTOR_SUB74KW = <any>'TRAKTOR_SUB74KW',
    TRAKTOR_AB74KW = <any>'TRAKTOR_AB74KW',
    TRAKTOR_AB74KW_KIPPER = <any>'TRAKTOR_AB74KW_KIPPER',
    TRAKTOR = <any>'TRAKTOR',
    TRAKTOR_4WD_SUB44KW = <any>'TRAKTOR_4WD_SUB44KW',
    TRAKTOR_4WD = <any>'TRAKTOR_4WD',
    TRANSPORTER = <any>'TRANSPORTER',
    TRANSPORTER_KIPPBRUECKE = <any>'TRANSPORTER_KIPPBRUECKE',
    ANHAENGER = <any>'ANHAENGER',
    FRONTLADER = <any>'FRONTLADER',
    HECKSCHAUFEL_PLANIERSCHILD = <any>'HECKSCHAUFEL_PLANIERSCHILD',
    ANBAUSEILWINDE = <any>'ANBAUSEILWINDE',
    HOLZ = <any>'HOLZ',
    HOLZ_AUF_PLATZ = <any>'HOLZ_AUF_PLATZ',
    BAGGER_1500 = <any>'BAGGER_1500',
    BAGGER_BIS5000 = <any>'BAGGER_BIS5000',
    BAGGER_AB5000 = <any>'BAGGER_AB5000',
    RAUPENTRANSPORTER = <any>'RAUPENTRANSPORTER',
    KETTENSAEGE = <any>'KETTENSAEGE',
    TERRA_TRAC_SUB44KW = <any>'TERRA_TRAC_SUB44KW',
    TERRA_TRAC_SUB74KW = <any>'TERRA_TRAC_SUB74KW',
    TELESKOPLADER = <any>'TELESKOPLADER',
    KLEINBAGGER_1_5T_BIS_3T = <any>'KLEINBAGGER_1_5T_BIS_3T',
    KLEINBAGGER_3_5T_BIS_6T = <any>'KLEINBAGGER_3_5T_BIS_6T',
    KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER = <any>'KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER',
    RAUPENKARETTE = <any>'RAUPENKARETTE',
    RAUPENTRANSPORTER_1_5T_BIS_4T = <any>'RAUPENTRANSPORTER_1_5T_BIS_4T',
    TREIBSTOFF = <any>'TREIBSTOFF',
    ANDERE = <any>'ANDERE',
}

export const EigenleistungsAnsatzMapVor2023: Map<TSEigenleistungArt, number> = new Map<TSEigenleistungArt, number>([
    [TSEigenleistungArt.HANDARBEIT, 25],
    [TSEigenleistungArt.TRAKTOR_SUB44KW, 30],
    [TSEigenleistungArt.TRAKTOR_SUB74KW, 35],
    [TSEigenleistungArt.TRAKTOR_AB74KW, 40],
    [TSEigenleistungArt.TRAKTOR, 24],
    [TSEigenleistungArt.TRAKTOR_4WD_SUB44KW, 23],
    [TSEigenleistungArt.TRAKTOR_4WD, 27],
    [TSEigenleistungArt.TRANSPORTER, 40],
    [TSEigenleistungArt.ANHAENGER, 15],
    [TSEigenleistungArt.FRONTLADER, 15],
    [TSEigenleistungArt.HECKSCHAUFEL_PLANIERSCHILD, 10],
    [TSEigenleistungArt.ANBAUSEILWINDE, 10],
    [TSEigenleistungArt.BAGGER_1500, 35],
    [TSEigenleistungArt.BAGGER_BIS5000, 45],
    [TSEigenleistungArt.BAGGER_AB5000, 50],
    [TSEigenleistungArt.RAUPENTRANSPORTER, 20],
    [TSEigenleistungArt.KETTENSAEGE, 15],
    [TSEigenleistungArt.HOLZ, 80],
]);

export const EigenleistungsAnsatzMapAb2023: Map<TSEigenleistungArt, number> = new Map<TSEigenleistungArt, number>([
    [TSEigenleistungArt.HANDARBEIT, 30],
    [TSEigenleistungArt.TRAKTOR_SUB44KW, 32],
    [TSEigenleistungArt.TRAKTOR_SUB74KW, 40],
    [TSEigenleistungArt.TRAKTOR_AB74KW, 60],
    [TSEigenleistungArt.TRAKTOR, 24],
    [TSEigenleistungArt.TRAKTOR_4WD_SUB44KW, 23],
    [TSEigenleistungArt.TRAKTOR_4WD, 27],
    [TSEigenleistungArt.TRANSPORTER, 55],
    [TSEigenleistungArt.ANHAENGER, 20],
    [TSEigenleistungArt.FRONTLADER, 15],
    [TSEigenleistungArt.HECKSCHAUFEL_PLANIERSCHILD, 10],
    [TSEigenleistungArt.ANBAUSEILWINDE, 10],
    [TSEigenleistungArt.BAGGER_1500, 35],
    [TSEigenleistungArt.BAGGER_BIS5000, 45],
    [TSEigenleistungArt.BAGGER_AB5000, 50],
    [TSEigenleistungArt.RAUPENTRANSPORTER, 20],
    [TSEigenleistungArt.KETTENSAEGE, 15],
    [TSEigenleistungArt.HOLZ, 80],
]);

export const EigenleistungsAnsatzMapAb2026: Map<TSEigenleistungArt, number> = new Map<TSEigenleistungArt, number>([
    [TSEigenleistungArt.HANDARBEIT, 30],
    [TSEigenleistungArt.TRAKTOR_SUB44KW, 50],
    [TSEigenleistungArt.TRAKTOR_SUB74KW, 60],
    [TSEigenleistungArt.TRAKTOR_AB74KW_KIPPER, 100],
    [TSEigenleistungArt.TERRA_TRAC_SUB44KW, 65],
    [TSEigenleistungArt.TERRA_TRAC_SUB74KW, 75],
    [TSEigenleistungArt.TRANSPORTER_KIPPBRUECKE, 90],
    [TSEigenleistungArt.TELESKOPLADER, 60],
    [TSEigenleistungArt.KLEINBAGGER_1_5T_BIS_3T, 40],
    [TSEigenleistungArt.KLEINBAGGER_3_5T_BIS_6T, 50],
    [TSEigenleistungArt.KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER, 70],
    [TSEigenleistungArt.RAUPENKARETTE, 25],
    [TSEigenleistungArt.RAUPENTRANSPORTER_1_5T_BIS_4T, 50],
    [TSEigenleistungArt.HOLZ_AUF_PLATZ, 80],
    [TSEigenleistungArt.TREIBSTOFF, 15],
]);

const preAb2026EigenleistungsArtValues: Array<TSEigenleistungArt> = [
    TSEigenleistungArt.HANDARBEIT,
    TSEigenleistungArt.HANDARBEIT_PAUSCHAL,
    TSEigenleistungArt.TRAKTOR_SUB44KW,
    TSEigenleistungArt.TRAKTOR_SUB74KW,
    TSEigenleistungArt.TRAKTOR_AB74KW,
    TSEigenleistungArt.TRANSPORTER,
    TSEigenleistungArt.ANHAENGER,
    TSEigenleistungArt.FRONTLADER,
    TSEigenleistungArt.HECKSCHAUFEL_PLANIERSCHILD,
    TSEigenleistungArt.ANBAUSEILWINDE,
    TSEigenleistungArt.BAGGER_1500,
    TSEigenleistungArt.BAGGER_BIS5000,
    TSEigenleistungArt.BAGGER_AB5000,
    TSEigenleistungArt.RAUPENTRANSPORTER,
    TSEigenleistungArt.KETTENSAEGE,
    TSEigenleistungArt.HOLZ,
    TSEigenleistungArt.ANDERE,
];

const ab2026EigenleistungsArtValues: Array<TSEigenleistungArt> = [
    TSEigenleistungArt.HANDARBEIT,
    TSEigenleistungArt.HANDARBEIT_PAUSCHAL,
    TSEigenleistungArt.TRAKTOR_SUB44KW,
    TSEigenleistungArt.TRAKTOR_SUB74KW,
    TSEigenleistungArt.TRAKTOR_AB74KW_KIPPER,
    TSEigenleistungArt.TRANSPORTER_KIPPBRUECKE,
    TSEigenleistungArt.TERRA_TRAC_SUB44KW,
    TSEigenleistungArt.TERRA_TRAC_SUB74KW,
    TSEigenleistungArt.TELESKOPLADER,
    TSEigenleistungArt.KLEINBAGGER_1_5T_BIS_3T,
    TSEigenleistungArt.KLEINBAGGER_3_5T_BIS_6T,
    TSEigenleistungArt.KLEINBAGGER_7T_BIS_10T_SCHREITBAGGER,
    TSEigenleistungArt.RAUPENKARETTE,
    TSEigenleistungArt.RAUPENTRANSPORTER_1_5T_BIS_4T,
    TSEigenleistungArt.HOLZ_AUF_PLATZ,
    TSEigenleistungArt.TREIBSTOFF,
    TSEigenleistungArt.ANDERE,
];

const  YEAR_2026 = '2026-04-30';

export function getEigenleistungsArtValues(schadendatum?: moment.Moment): Array<TSEigenleistungArt> {
    if (schadendatum !== undefined && schadendatum.isAfter( YEAR_2026)) {
        return [...ab2026EigenleistungsArtValues];
    }
    return [...preAb2026EigenleistungsArtValues];
}

export function eigenleistungPrefix(): string {
    return 'TSEigenleistungArt_';
}

export function getEigenleistungsAnsatz(art: TSEigenleistungArt, schadendatum: moment.Moment | undefined): number {
    let ansatz: number | undefined;

    if (schadendatum !== undefined && schadendatum.isAfter( YEAR_2026)) {
        ansatz = EigenleistungsAnsatzMapAb2026.get(art);
    } else if (schadendatum !== undefined && schadendatum.isAfter('2022-12-31')) {
        ansatz = EigenleistungsAnsatzMapAb2023.get(art);
    } else {
        ansatz = EigenleistungsAnsatzMapVor2023.get(art);
    }

    return ansatz === undefined ? 0 : ansatz;
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSEigenleistungArt.ts